const CertificationBadge = ({ moduleCertification }) => {
    return (
        <div className='df aic jcc' style={{ width: '64px', height: '64px' }}>
            {moduleCertification === 'Bronze' && (
                <img className="h4rem" src={require('../../../../images/bronze-cup.png')} alt="bronze" />
            )}
            {moduleCertification === 'Silver' && (
                <img className="h4rem" src={require('../../../../images/silver-cup.png')} alt="silver" />
            )}
            {moduleCertification === 'Gold' && (
                <img className="h4rem" src={require('../../../../images/gold-cup.png')} alt="gold" />
            )}
            {(!moduleCertification || moduleCertification === 'None') && (
                <img className="h4rem" src={require('../../../../images/gold-cup.png')} alt="certification" style={{ opacity: 0.35, filter: 'grayscale(1)' }} />
            )}
        </div>
    );
};

export default CertificationBadge;
